import { render, staticRenderFns } from "./PaymentViewV2.vue?vue&type=template&id=cb1f5760"
import script from "./PaymentViewV2.vue?vue&type=script&lang=js"
export * from "./PaymentViewV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports